import { cn } from '@/utils/cn.ts';

interface ResizeHandleProps {
	onMouseDown: (e: React.MouseEvent) => void;
	isDragging: boolean;
}

export const ResizeHandle = ({
	onMouseDown,
	isDragging,
}: ResizeHandleProps) => {
	return (
		<div
			data-testid="resize-handle"
			className={cn(
				`group flex w-4 flex-shrink-0 cursor-col-resize items-center
				justify-center self-stretch`,
			)}
			onMouseDown={onMouseDown}
		>
			<div className="relative flex h-full items-center justify-center">
				<div
					className={cn(
						'h-full w-0.5 rounded-full transition-colors',
						isDragging
							? 'bg-white/30'
							: 'bg-transparent group-hover:bg-white/20',
					)}
				/>
				<div
					className={cn(
						'absolute flex flex-col gap-1 transition-opacity',
						isDragging ? 'opacity-80' : 'opacity-0 group-hover:opacity-60',
					)}
				>
					<div className="h-1 w-1 rounded-full bg-white" />
					<div className="h-1 w-1 rounded-full bg-white" />
					<div className="h-1 w-1 rounded-full bg-white" />
				</div>
			</div>
		</div>
	);
};
